import { Component, Input, NgModule, OnInit } from '@angular/core';
import { CommonModule, JsonPipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'tw-page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.css'],
    imports: [MatIcon, JsonPipe]
})
export class PageNotFoundComponent implements OnInit {
    @Input() message: any;
    showError = false;

    constructor() {
    }

    ngOnInit() {
    }

}


@NgModule({
    declarations: [],
    imports: [
        CommonModule
    ]
})
export class PageNotFoundModule {

}

